module.exports = __webpack_public_path__ + "static/media/failed-capture-eight.b84c9c35.png";